/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_dateperiod.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value into a `date_period` value.
 *
 * @example
 * ROW x = "2024-01-01"::datetime
 * | EVAL y = x + "3 DAYS"::date_period, z = x - TO_DATEPERIOD("3 days");
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_dateperiod',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'date_period',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'date_period',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'date_period',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'date_period',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
